module.exports = __webpack_public_path__ + "static/media/empty.ceb9e9c3.svg";